export default __webpack_public_path__ + "static/media/cuposExample.a3b4f7a3.svg";